export default "__VITE_ASSET__gnlmLRsF__"